import { DOCUMENT } from '@angular/common';
import { Inject, inject, Injectable, Renderer2 } from '@angular/core';
import { AppConfigService } from '../config/app-config.service';

declare var gtag: Function;

// GA cross-domain linker — same for all environments
const GA_LINKER_DOMAINS = ['edgebuildings.com'];

@Injectable({
    providedIn: 'root'
})
export class GoogleService {

    private readonly appConfigService = inject(AppConfigService);

    private get googleAnalyticsAccount(): string {
        return this.appConfigService.config()?.analytics?.googleAnalyticsAccount ?? '';
    }
    private get ga4MeasurementId(): string {
        return this.appConfigService.config()?.analytics?.ga4MeasurementId ?? '';
    }

    constructor(@Inject(DOCUMENT) private doc: Document) {}

    initializeAnalytics(renderer: Renderer2): void {
        const accountId = this.googleAnalyticsAccount;
        if (!accountId) return;

        if (this.doc.querySelector('script[data-gtag-initialized]')) return;

        const gtagSrc = renderer.createElement('script') as HTMLScriptElement;
        renderer.setAttribute(gtagSrc, 'async', '');
        renderer.setAttribute(gtagSrc, 'src', `https://www.googletagmanager.com/gtag/js?id=${accountId}`);
        renderer.setAttribute(gtagSrc, 'data-gtag-initialized', 'true');
        renderer.appendChild(this.doc.head, gtagSrc);

        const gtagInit = renderer.createElement('script') as HTMLScriptElement;
        gtagInit.text = [
            'window.dataLayer = window.dataLayer || [];',
            'function gtag(){ dataLayer.push(arguments); }',
            'gtag(\'js\', new Date());',
            `gtag('config', '${accountId}', { linker: { domains: ${JSON.stringify(GA_LINKER_DOMAINS)} } });`,
            this.ga4MeasurementId
                ? `gtag('config', '${this.ga4MeasurementId}', { linker: { domains: ${JSON.stringify(GA_LINKER_DOMAINS)} } });`
                : ''
        ].join('\n');
        renderer.appendChild(this.doc.head, gtagInit);
    }

    google_conversion_label(selectedLanguage): string {
        var google_conversion_label;
        switch (selectedLanguage) {
            case 'English':
                google_conversion_label = "Lv8nCKXagnAQxKnjuQM";
                break;
            case 'Spanish':
                google_conversion_label = "3BmMCMb6pHAQxKnjuQM";
                break;
            case 'Portuguese':
                google_conversion_label = "GAfxCOn_pHAQxKnjuQM";
                break;
            case 'Vietnamese':
                google_conversion_label = "l4vGCNujt3AQxKnjuQM";
                break;
            default:
                google_conversion_label = "Lv8nCKXagnAQxKnjuQM";
                break;
        }

        return google_conversion_label;
    }

    sendRegisterCustomerConversionToGoogleAnalytics(selectedLanguage) {
        if (!selectedLanguage) {
            selectedLanguage = 'English';
        }

        if (typeof gtag !== 'undefined' && this.googleAnalyticsAccount) {
            gtag('event', 'EDGEApp-register-user', {
                method: 'Submission',
                event_category: 'Register',
                event_label: 'EDGE App Form Submission-' + selectedLanguage,
                send_to: "'" + this.googleAnalyticsAccount + "'/" + this.google_conversion_label(selectedLanguage)+"'"
            });
        }
    }
}
